module.exports = __webpack_public_path__ + "img/icon_map_6_off_111.4dd3111b.png";